import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { default as axios, AxiosResponse } from 'axios';
import { IRootState, IDataState } from './contract';
import { IAccountCluster } from '@/contracts/AccountClusterContract';
import { IAccount, IActiveAccount } from '@/contracts/AccountContract';
import { IAllocations } from '@/contracts/AllocationContract';
import { IEmployeesFlat } from '@/contracts/EmployeeContract';
import { IRootHypermediaRepresentation } from '@/contracts/RootContract';
import { ISkill } from '@/contracts/SkillContract';
import { ITribe } from '@/contracts/TribeContract';
import { IHive } from "@/contracts/HiveContract";
import {ICapability} from "@/contracts/CapabilityContract";

const exportState: IDataState = {
    tribes: [],
    hives: [],
    accounts: [],
    accountClusters:[],
    activeAccounts: [],
    flatEmployees: undefined,
    skills: [],
    capabilities: []
};

const mutations: MutationTree<IDataState> = {
    tribesLoaded(state, payload: ITribe[]) {
        state.tribes = payload;
    },
    hivesLoaded(state, payload: IHive[]) {
        state.hives = payload;
    },
    accountClustersLoaded(state, payload: IAccountCluster[]) {
        state.accountClusters = payload;
    },
    accountsLoaded(state, payload: IAccount[]) {
        state.accounts = payload;
    },
    employeesLoaded(state, payload: IEmployeesFlat) {
        state.flatEmployees = payload;
        let activeAccountsById: { [accountId: string]: boolean } = {};

        state.activeAccounts = payload.Allocations.map((allocation: IAllocations) => {
            return {
                Id: allocation.AccountId,
                Name: allocation.AccountName
            };
        }).filter((ac: IActiveAccount) => {
            if (activeAccountsById[ac.Id]) {
                return false;
            }
            activeAccountsById[ac.Id] = true;
            return true;
        });
    },
    skillsLoaded(state, payload: ISkill[]) {
        state.skills = payload;
    },
    capabilitiesLoaded(state, payload: ICapability[]) {
        state.capabilities = payload;
    }
};

const actions: ActionTree<IDataState, IRootState> = {
    async fetchTribes({ commit, state, rootState }): Promise<void> {
        if (!state.tribes.length) {
            const response: AxiosResponse<ITribe[]> = await axios.get((rootState.root as IRootHypermediaRepresentation)._links.tribes.href);
            commit('tribesLoaded', response && response.data);
        }
    },
    async fetchHives({ commit, state, rootState }): Promise<void> {
        if (!state.hives.length) {
            const response: AxiosResponse<IHive[]> = await axios.get((rootState.root as IRootHypermediaRepresentation)._links.hives.href);
            commit('hivesLoaded', response && response.data);
        }
    },
    async fetchAccountClusters({ commit, state, rootState }): Promise<void> {
        if (!state.accountClusters.length) {
            const response: AxiosResponse<IAccountCluster[]> = await axios.get((rootState.root as IRootHypermediaRepresentation)._links.accountClusters.href);
            commit('accountClustersLoaded', response && response.data);
        }
    },
    async fetchAccounts({ commit, state, rootState }): Promise<void> {
        if (!state.accounts.length) {
            const response: AxiosResponse<IAccount[]> = await axios.get((rootState.root as IRootHypermediaRepresentation)._links.accounts.href);
            commit('accountsLoaded', response && response.data);
        }
    },
    async fetchEmployees({ commit, state, rootState }): Promise<void> {
        if (!state.flatEmployees || !state.activeAccounts.length) {
            const response: AxiosResponse<IEmployeesFlat> = await axios.get((rootState.root as IRootHypermediaRepresentation)._links.employees.href);
            commit('employeesLoaded', response && response.data);
        }
    },
    async fetchSkills({ commit, state, rootState }): Promise<void> {
        if (!state.skills.length) {
            const response: AxiosResponse<ISkill[]> = await axios.get((rootState.root as IRootHypermediaRepresentation)._links.skills.href);
            commit('skillsLoaded', response && response.data);
        }
    },
    async fetchCapabilities({ commit, state, rootState }): Promise<void> {
        if (!state.capabilities.length) {
            const response: AxiosResponse<ISkill[]> = await axios.get((rootState.root as IRootHypermediaRepresentation)._links.capabilities.href);
            commit('capabilitiesLoaded', response && response.data);
        }
    }
};

const getters: GetterTree<IDataState, IRootState> = {};

const namespaced: boolean = true;

export const data: Module<IDataState, IRootState> = {
    namespaced,
    state: exportState,
    getters,
    actions,
    mutations
};
